import React, { useState, useEffect } from 'react';
import Question1 from './Question1';
import { Cureus } from '../../../Cureus';
import Question2 from './Question2';
import Question3 from './Question3';
import Question4 from './Question4';
import Question5 from './Question5';
import Question6 from './Question6';

const Main = ({ article, startOverPath, initialStep, questionFlow }) => {
  const [submitDisabled, setSubmitDisabled] = useState('disabled');
  const [newStudyDesign, setNewStudyDesign] = useState(article.study_design_type);
  const [startOverDisabled, setStartOverDisabled] = useState('disabled');
  const [currentStep, setCurrentStep] = useState(initialStep);

  const componentMap = {
    Question1: Question1,
    Question2: Question2,
    Question3: Question3,
    Question4: Question4,
    Question5: Question5,
    Question6: Question6
  };

  const [questionResponse, setQuestionResponse] = useState(initialStep !== null ?questionFlow[initialStep].question.initial_state : []);  

  useEffect(() => {
    new Cureus.InstaSaver("#save-now");
    Cureus.ChangeDetectorAlert.init("form");
    if(questionResponse.some(value => value !== null)) {
      setSubmitDisabled('');
    }
  }, []);

  useEffect(() => {
    if (questionResponse.some(value => value !== null)) {
      setStartOverDisabled('');
    }
  }, [questionResponse]);

  const handleResponse = (questionId, responseValue) => {
    const currentQuestion = questionFlow[questionId];
    
    if (currentQuestion.logic && currentQuestion.logic[responseValue]) {
      const logic = currentQuestion.logic[responseValue];
      
      if (logic.newStudyDesign !== undefined) {
        setNewStudyDesign(logic.newStudyDesign);
      }
      setSubmitDisabled(logic.submitDisabled);
      
      if (logic.nextStep !== null) {
        setCurrentStep(logic.nextStep);
      } else {
        setCurrentStep(currentQuestion.question.step)
      }
    }
  };
  
  const handleStartOver = () => {
    $.ajax({
      type: 'PUT',
      url: startOverPath,
      data: { },
      success: (response) => {
        setQuestionResponse([null, null, null, null, null, null]);
        setNewStudyDesign(null);
        setStartOverDisabled('disabled');
        setCurrentStep(null)
      },
      error: (error) => {
        Cureus.Flash.alert("There was an error starting over. Please try again.");
      }
    });
  }

  return (
    <div className="study-design-container">
      <h2>Let's double-check your study design.</h2>
      <p>In this step, we'll help you identify the correct study design for your article based on a few quick questions. This ensures you meet all necessary compliance requirements, such as IRB review or clinical trial registration, before moving forward. Your responses will automatically generate your study classification (e.g, retrospective, prospective interventional) and a list of requirements, helping you avoid delays or issues later in the editorial process.
</p>
      {questionFlow.slice(0, currentStep + 1).map(flowItem => {
        const CurrentComponent = componentMap[flowItem.component];
        return (
          <CurrentComponent
            key={flowItem.step}
            setQuestionResponse={setQuestionResponse}
            response={questionResponse[flowItem.questionId]}
            question={flowItem.question}
            setSubmitDisabled={setSubmitDisabled}
            handleResponse={handleResponse}
          />
        );
      })}

      <input type='hidden' name='study_design' value={newStudyDesign} />
      <div className="step-actions clearfix">
        <div className="row">
          <div className="pull-right">
            <div className="save-success-message" id="save-success-message">
              You have successfully saved your progress.
            </div>
          </div>
        </div>
        <div className="pull-right">
          <input id="start-over" className="button special" onClick={handleStartOver} disabled={startOverDisabled} type="button" value="Start Over" />
          &nbsp;
          <input id="save-now" className="button special" data-disable-with="Save" disabled={submitDisabled} data-alert-exception type="button" value="Save" />
          &nbsp;
          <input className="button primary" data-disable-with="Save and continue" disabled={submitDisabled} name="commit" type="submit" value="Save and continue" data-alert-exception />
        </div>
      </div>
    </div>
  );
};

export default Main;